import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIApplication = (namespace: CreateNS) => {
    namespace('application')(({ func, prop, deps }) => {
        prop('exitApp', () => deps.exitApp, null);
        func('restartApp', deps.restartApp);
        func('playerTarget', deps.getPlayerTarget);
        prop('environmentGroup', deps.getEnvironmentGroup, null);
        prop('environment', deps.getEnvironment, null);
        prop('type', deps.getApplicationType, null);
    });
};
